export function themeResolver(color_theme) {
  switch (color_theme) {
    case "Kelp":
      return { bg: "kelp", btn: "poppy", color: "primary" }
    case "Poppy":
      return { bg: "poppy", btn: "poppy", color: "primary" }
    case "Plush":
      return { bg: "plush", btn: "poppy", color: "primary" }
    case "Ice":
      return { bg: "ice", btn: "green", color: "primary" }
    case "Foam":
      return { bg: "plush", btn: "poppy", color: "primary" }
    default:
      return { bg: "white", btn: "poppy", color: "primary" }
  }
}
